import { Circle, Warehouse } from '@phosphor-icons/react';
import { TableCell, TableRow } from 'semantic-ui-react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { DateFormat, DateUtility, theme } from '../../../utility';
import { ColoredPill, StyledButton } from '../../../elements';

const NameContainer = styled.div`
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export function RateRow({ item }) {
  return (
    <TableRow>
      <TableCell>{item.name}</TableCell>
      <TableCell>
        <div className="d-flex justify-content-start align-items-center">
          <Warehouse size={20} className="mr-2" color={theme.colors.grey} />
          <NameContainer>{item?.warehouseId?.name}</NameContainer>
        </div>
      </TableCell>
      <TableCell>{DateUtility.formatDate(item.createdAt, DateFormat.dateTime)}</TableCell>
      <TableCell>{item.description}</TableCell>
      <TableCell>
        {item.isActive ? (
          <ColoredPill color={theme.colors.green}>
            <Circle weight="fill" />
            Active
          </ColoredPill>
        ) : (
          <ColoredPill color={theme.colors.red}>
            <Circle weight="fill" />
            Not Active
          </ColoredPill>
        )}
      </TableCell>
      <TableCell>
        <Link to={`/app/settings/services-rates/${item._id}`}>
          <StyledButton>Details</StyledButton>
        </Link>
      </TableCell>
    </TableRow>
  );
}
